var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Nav'),_c('Header'),_c('div',{staticClass:"page-body"},[_c('router-view')],1),_c('Footer'),_c('CustomService')],1)}
var staticRenderFns = []

export { render, staticRenderFns }